import plans from "../components/plans/data/plans";

const getPlanFromName = (planName) => {
  return plans.filter((plan) => plan.name === planName)[0];
};
export default getPlanFromName;
